package de.oevbs.kunde.kundenportal2.navigation.components

import de.oevbs.kosmos.ui.icons.icon
import de.oevbs.kunde.kundenportal2.authentication.PortalSession
import de.oevbs.kunde.kundenportal2.authentication.hasAuthority
import de.oevbs.kunde.kundenportal2.children
import de.oevbs.kunde.kundenportal2.components.ContentHook
import de.oevbs.kunde.kundenportal2.components.headerImageLayout
import de.oevbs.kunde.kundenportal2.navigation.Page
import de.oevbs.kunde.kundenportal2.navigation.visit
import dev.fritz2.core.RenderContext
import dev.fritz2.core.joinClasses
import dev.fritz2.headless.foundation.hook

/**
 * Rendert eine Übersichtsseite, die die einzelnen Unterseiten der angegebenen [page] als Kacheln darstellt.
 *
 * Siehe [subPagesOverview] für die vollständige Dokumentation.
 */
class SubPageOverview(private val page: Page) {

    /**
     * Content, der als Beschreibung zwischen dem Titel/Header und den Kacheln für die Unterseiten gerendert werden
     * soll.
     */
    val description: ContentHook = ContentHook()

    private fun RenderContext.subPageButton(page: Page) {
        button(
            joinClasses(
                "p-4 md:p-8 group flex flex-col items-center gap-4 border rounded-sm bg-white",
                "[&:not(:hover)]:shadow hover:border-primary-100",
                "bg-opacity-90"
            )
        ) {
            page.icon?.let {
                icon("w-24 h-24 md:w-28 md:h-28 text-primary-300 group-hover:text-primary-600", icon = it)
            }
            span("max-w-full text-lg overflow-ellipsis overflow-hidden") {
                +page.linkTitle
            }
        }.clicks handledBy {
            page.visit()
        }
    }

    fun RenderContext.render() {
        div("flex flex-col gap-4 lg:gap-8") {
            hook(description)

            div("grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-1") {
                PortalSession.data.render { principal ->
                    page.children.filter {
                        it.showInMenu && hasAuthority(principal, it.roleForMenu)
                    }.forEach { subpage ->
                        subPageButton(subpage)
                    }
                }
            }
        }
    }
}

/**
 * Rendert ein Grid mit den einzelnen Unterseiten der angegebenen [page] als Kacheln.
 *
 * Mittels [SubPageOverview.description] kann ein Beschreibungstext hinzugefügt werden, der über dem Grid angezeigt
 * wird.
 * Wird [SubPageOverview]
 *
 * Wird eine Kachel angeklickt, wird zur entsprechenden Unterseite navigiert.
 *
 * Wird in der Regel als Content für ein [headerImageLayout] verwendet.
 */
fun RenderContext.subPagesOverview(
    page: Page,
    initialize: SubPageOverview.() -> Unit = {}
): Unit =
    SubPageOverview(page).apply(initialize).run { render() }